import { useCookiePrefAsync } from '#src/app/shared/hooks/session';
import { isLoaded } from '#src/app/shared/utils/async';
import { getTikTokPlayerUrl } from '#src/app/shared/utils/socialMedia';

export type VideoFirstHeroStatus = 'fallback' | 'pending' | 'rendered';

export function useVideoFirstHeroStatus(sourceUrl: string | undefined): VideoFirstHeroStatus {
	const marketingCookies = useCookiePrefAsync('marketing');
	const playerUrl = sourceUrl ? getTikTokPlayerUrl(sourceUrl) : undefined;

	if (!playerUrl) return 'fallback';
	if (!isLoaded(marketingCookies)) return 'pending';

	return marketingCookies.value ? 'rendered' : 'fallback';
}
